$(document).ready(function () {

    function getAnswers() {
        var petName = $('.qz__name_input').val();
        var catOrDog = $('.Question_amount').attr('data-animal');
        var old = $('.Question_amount').attr('data-old');
        var color = $('.Question_amount').attr('data-color');
        var allergies = $('.Question_amount').attr('data-allergies');
        var weight = $('.Question_amount').attr('data-weight');

        var properties = "Name=" + petName + '";Type="' + catOrDog + '";HowOld="' + old + '";WhatColor="' + color + '";Allergies="' + allergies + '";Weight="' + weight + '";';
        return properties;
    }

    function setAllergies() {
        var allergies = '';
        $('.qz_allergies_grid').find('.Multiple_question_trigger__js.active').each(function () {
            var thisAllergy = $(this).find('.allergy_val').attr('data');
            allergies = allergies + thisAllergy + ';';
        });
        $('.Question_amount').attr('data-allergies', allergies);
    }

    $('.qz_btn_mode').click(function () {
        $('.qz_btn_mode').removeClass('active');
        $(this).addClass('active');
        var data = $(this).attr('data');

        if (data == 'onetime') {
            $('.qz_product_price_sub').hide();
            $('.qz_product_price_otp').show();
            $('.qz_points_sub').hide();
            $('.qz_points_otp').show();
            $('.qz_product_sub_selection_outer').hide();
            $('.visibleOnlyForSub').hide();
        } else if (data == 'subscribe') {
            $('.qz_product_price_sub').show();
            $('.qz_product_price_otp').hide();
            $('.qz_points_sub').show();
            $('.qz_points_otp').hide();
            $('.qz_product_sub_selection_outer').show();
            $('.visibleOnlyForSub').show();
        }
    });

    $('.quiz_email_checkbox').click(function () {
        if ($(this).hasClass('active')) {
            $('.quiz_email_checkbox').removeClass('active');
        } else {
            $('.quiz_email_checkbox').addClass('active');
        }

    });

    $('.qz_breed_selection_input').keyup(function () {
        var value = $(this).val();
        value = String(value).toLowerCase();

        $('.qz_breed_inner_box_label').hide();
        $('.qz_breed_inner_box_label').each(function () {
            var thisVal = String($(this).find('span').html().toLowerCase());
            if (thisVal.indexOf(value) != -1) {
                $(this).show();
            }
        });
    });

    function moveToNextQuestion(thisEl) {


        var current_index = parseFloat(thisEl.attr('data-index'));
        var next_index = current_index + 1;
        var current_question_index = parseFloat(thisEl.attr('data-question-index'));


        // Progress bar width selection
        var width;
        var question_length = parseFloat($('.Question_amount').val()) + 1;
        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
        var multiplier = 100 / only_questions;
        width = (current_question_index) * multiplier;
        console.log(width, current_question_index, multiplier);

        $('.Answer_block').removeClass('active');
        thisEl.addClass('active');
        setTimeout(function () {
            if (question_length == next_index) {
                var animal = $('.Question_amount').attr('data-animal');
                var properties = getAnswers();
                // setTimeout(function(){
                //     // window.location.href = '/pages/quiz-email?' + properties;
                // },500);
                window.location.href = '/pages/quiz-email?' + properties;
                sendDataToSheet();
            } else {
                $('.Quiz_question').hide();
                $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
                // $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                $('.Quiz_header_back').css('opacity', '1');
                $('.Quiz_header_back').css('cursor', 'pointer');
                $('.Quiz_header_back').attr('data-current', next_index);
                calculateTop();
            }
        }, 200);

    }

    function calculateTop() {
        var currentIndex = parseFloat($('.Quiz_header_back').attr('data-current'));
        var totalIndexes = parseFloat($('.Question_amount').attr('value'));

        if (currentIndex == 1) {
            currentIndex = 1;
        }
        $('.Quiz_header_question_info_js').html(currentIndex + ' of ' + totalIndexes);
        var percentage = currentIndex * 100 / totalIndexes;

        $('.Quiz-header_progres_bar__inner').css('width', percentage + '%');
    }


    $('.qz_weight_mea__curr').click(function () {
        $(this).closest('.qz_cat_weight_measurement_cont').find('.qz_weight_mea__curr').removeClass('active');
        $(this).addClass('active');
    });

    $('.qz_not_sure__label').click(function () {
        var thisEl = $(this).closest('.qz_breed_selection_answering');
        moveToNextQuestion(thisEl);
    });

    $('.qz_breed_inner_box_label').click(function () {
        var currentValue = $(this).find('span').html();
        $('.qz_breed_selection_input').val(currentValue);
        $('.qz_breed_selector_inner_box').hide();
        var thisEl = $(this).closest('.qz_breed_selection_answering');
        window.localStorage.setItem("breed", currentValue);
        moveToNextQuestion(thisEl);
    });

    $('.qz_breed_selection_input').click(function () {
        $('.qz_breed_selector_inner_box').toggle();
    });

    $('.Next_question_trigger__js').click(function () {

        var current_index = parseFloat($(this).attr('data-index'));
        var next_index = current_index + 1;
        var current_question_index = parseFloat($(this).attr('data-question-index'));

        if (current_index === 16) {
            saveToLocalStorage();
        }

        // Progress bar width selection
        var width;
        var question_length = parseFloat($('.Question_amount').val()) + 1;
        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
        var multiplier = 100 / only_questions;
        width = (current_question_index) * multiplier;
        console.log(width, current_question_index, multiplier);


        var showCatDog = 0;
        if ($(this).closest('.Answer_container_gap_top').hasClass('show_cat_dog_content')) {
            showCatDog = 1;
            var showCatDogValue = $(this).find('span.Answer').attr('data');

            console.log(showCatDogValue, 'CAT OR DOG')
            $('.quiz_body_condition_container').hide();
            $('.Answer_container_weight').hide();
            $('.Question_amount').attr('data-animal', showCatDogValue);

            if (showCatDogValue == 'dog') {
                $('.quiz_body_condition_container[data="dogs"]').css('display', 'flex');
                $('.Answer_container_weight[data="dogs"]').show();
                $('.answer_dog').show();
                $('.answer_cat').hide();
                $('.breed_selector_typed[data="dog"]').show();
            } else {
                $('.quiz_body_condition_container[data="cats"]').css('display', 'flex');
                $('.Answer_container_weight[data="cats"]').show();
                $('.answer_dog').hide();
                $('.answer_cat').show();
                $('.breed_selector_typed[data="cat"]').show();
            }
        }

        var Years = 0;
        if ($(this).closest('.Answer_container_gap_top').hasClass('show_years')) {
            if (Years == 0) {
                var showYears = $(this).find('span.Answer').attr('data');
                $('.Question_amount').attr('data-old', showYears);
                Years = 1;
            }
        }

        var Color = 0;
        if ($(this).closest('.Answer_container_gap_top').hasClass('show_color')) {
            if (Color == 0) {
                var showColor = $(this).find('span.Answer').attr('data');
                $('.Question_amount').attr('data-color', showColor);
                Color = 1;
            }
        }

        var Weight = 0;
        if ($(this).closest('.Answer_container_grid').hasClass('hasWeight')) {
            if (Weight == 0) {
                Weight = 1;
                var thisWeight = $(this).attr('data-answer');
                $('.Question_amount').attr('data-weight', thisWeight);
            }
        }


        // Change color
        $('.Answer_block').removeClass('active');
        $(this).addClass('active');
        setTimeout(function () {
            if (question_length == next_index) {
                var animal = $('.Question_amount').attr('data-animal');
                var properties = getAnswers();
                // setTimeout(function(){
                //     // window.location.href = '/pages/quiz-email?' + properties;
                // },500);
                window.location.href = '/pages/quiz-email?' + properties;
                sendDataToSheet();
            } else {

                $('.Quiz_question').hide();
                $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
                // $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                // $('.Quiz_header_question_info_js').text(current_question_index+' of '+only_questions);
                $('.Quiz_header_back').css('opacity', '1');
                $('.Quiz_header_back').css('cursor', 'pointer');
                $('.Quiz_header_back').attr('data-current', next_index);
                calculateTop();
                getAnswers();
                sendDataToSheet();

            }
        }, 200);

        var currentQuestionTitle = $(this).closest('.Quiz_question').find('.Quiz_medium_title').html();
        var currentValue = $(this).attr('data-answering');

        var fullQuestionString = currentQuestionTitle + '==' + currentValue + '/';

        console.log(fullQuestionString);
        var currentData = $('.Question_amount').attr('data-quiz-data');
        currentData = currentData + fullQuestionString;
        $('.Question_amount').attr('data-quiz-data', currentData);


    });

    $('.Multiple_question_trigger__js').click(function () {
        $(this).toggleClass('active');
        var selected_selector = 0;
        $('.Multiple_question_trigger__js').each(function () {
            if ($(this).hasClass('active')) {
                selected_selector++;
            }
        });
        console.log(selected_selector);
        if (selected_selector != 0) {
            $('.Multiple_question_next__js').removeClass('disabled');
        } else {
            $('.Multiple_question_next__js').addClass('disabled');
        }

    });

    $('.Multiple_question_next__js').click(function () {
        if ($(this).hasClass('disabled')) {

        } else {

            var currentQuestionTitle = $(this).closest('.Quiz_question').find('.Quiz_medium_title').html();
            var currentValue = '';
            $('.Multiple_question_trigger__js.active').each(function () {
                if (typeof ($(this).attr('data-answering')) != 'undefined') {
                    // console.log($(this).attr('data-answering'), 'testing');
                    currentValue = currentValue + $(this).attr('data-answering') + ';';
                }

            });

            var fullQuestionString = currentQuestionTitle + '==' + currentValue + '/';

            console.log(fullQuestionString);


            var current_index = parseFloat($(this).attr('data-index'));
            var next_index = current_index + 1;
            var current_question_index = parseFloat($(this).attr('data-question-index'));

            // Indexing quiz questions
            var current_url = window.location.href;
            if (current_url.indexOf('#') != -1) {
                var next_url_index = next_index;
                var new_url = url_splitted[0] + '#' + next_url_index;
                // console.log(new_url);

            }

            if ($(this).hasClass('allergiesBtn')) {
                setAllergies();
            }

            // console.log(next_index);
            $('.Quiz_question').hide();
            $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
            $('.Multiple_question_next__js').addClass('disabled');
            $('.Multiple_question_trigger__js').removeClass('active');
            // Progress bar width selection
            var width;
            var question_length = parseFloat($('.Question_amount').val()) + 1;
            var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
            var multiplier = 100 / only_questions;

            width = (current_question_index) * multiplier;
            console.log(width, current_question_index, multiplier);

            getAnswers();

            if (question_length == next_index) {
                var animal = $('.Question_amount').attr('data-animal');
                var properties = getAnswers();
                // setTimeout(function(){
                //     // window.location.href = '/pages/quiz-email?' + properties;
                // },500);
                window.location.href = '/pages/quiz-email?' + properties;
                sendDataToSheet();
            } else {

                // $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                $('.Quiz_header_back').css('opacity', '1');
                $('.Quiz_header_back').css('cursor', 'pointer');
                $('.Quiz_header_back').attr('data-current', next_index);
                calculateTop();
            }


            var currentData = $('.Question_amount').attr('data-quiz-data');
            currentData = currentData + fullQuestionString;
            $('.Question_amount').attr('data-quiz-data', currentData);

        }


    });

    $('.Text_question_next__js').click(function () {
        var current_index = parseFloat($(this).attr('data-index'));
        var next_index = current_index + 1;
        var next_question_index = parseFloat($('.Quiz_question_' + current_index + '__js').attr('data-question-index'));
        console.log(current_index, next_index, next_question_index)
        // Indexing quiz questions
        var current_url = window.location.href;
        if (current_url.indexOf('#') != -1) {
            var next_url_index = next_index;
            var new_url = url_splitted[0] + '#' + next_url_index;
            // console.log(new_url);

        }
        // console.log(next_index);
        $('.Quiz_question').hide();
        $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
        // Progress bar width selection
        var width;
        var question_length = parseFloat($('.Question_amount').val()) + 1;
        var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
        var multiplier = 100 / only_questions;
        // if (next_index < 6){
        //     width = (next_index+2) * multiplier;
        // }
        // else if (next_index >= 6 && next_index < 12){
        //     width = (next_index +1)* multiplier;
        // }
        // else{
        //     width = next_index *multiplier;
        //  }
        width = next_question_index * multiplier;

        if (question_length == next_index) {
            var animal = $('.Question_amount').attr('data-animal');
            var properties = getAnswers();
            // setTimeout(function(){
            //     // window.location.href = '/pages/quiz-email?' + properties;
            // },500);
            window.location.href = '/pages/quiz-email?' + properties;
            sendDataToSheet();
        } else {
            // $('.Quiz-header_progres_bar__inner').css('width', width+'%');
            $('.Quiz_header_question_info_js').text(next_question_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '1');
            $('.Quiz_header_back').attr('data-current', next_index);
            $('.Quiz_header_back').css('cursor', 'pointer');
            calculateTop();
        }


    });


    $('.Text_question_next__js__input').click(function () {
        var typedValue = $(this).closest('.Quiz_question_inner').find('.qz_text_input').val();
        var typedName = $(this).closest('.Quiz_question_inner').find('.qz_text_input.qz__name_input').val();

        if (typedValue.length > 0) {

            // Adding name to all questions
            $('.Quiz_medium_title').each(function () {
                var currentTitle = $(this).html();
                currentTitle = currentTitle.replace('(name)', typedName);
                $(this).html(currentTitle);
            });

            $('.Answer_block').each(function () {
                var currentAnswer = String($(this).find('.Answer').html());
                currentAnswer = currentAnswer.replace('[name]', typedName);
                $(this).find('.Answer').html(currentAnswer);
            });

            var current_index = parseFloat($(this).attr('data-index'));
            var next_index = current_index + 1;
            var next_question_index = parseFloat($('.Quiz_question_' + current_index + '__js').attr('data-question-index'));
            console.log(current_index, next_index, next_question_index)
            // Indexing quiz questions

            $('.Quiz_question').hide();
            $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
            // Progress bar width selection
            var width;
            var question_length = parseFloat($('.Question_amount').val()) + 1;
            var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
            var multiplier = 100 / only_questions;

            width = next_question_index * multiplier;

            if (question_length == next_index) {
                var animal = $('.Question_amount').attr('data-animal');
                var properties = getAnswers();
                // setTimeout(function(){
                //     // window.location.href = '/pages/quiz-email?' + properties;
                // },500);
                window.location.href = '/pages/quiz-email?' + properties;
                sendDataToSheet();
            } else {

                // $('.Quiz-header_progres_bar__inner').css('width', width+'%');
                $('.Quiz_header_back').css('opacity', '1');
                $('.Quiz_header_back').attr('data-current', next_index);
                $('.Quiz_header_back').css('cursor', 'pointer');
                calculateTop();
            }

            getAnswers();

            var currentQuestionTitle = $(this).closest('.Quiz_question').find('.Quiz_medium_title').html();
            var currentValue = typedValue;

            var fullQuestionString = currentQuestionTitle + '==' + currentValue + '/';

            console.log(fullQuestionString);
            var currentData = $('.Question_amount').attr('data-quiz-data');
            currentData = currentData + fullQuestionString;
            $('.Question_amount').attr('data-quiz-data', currentData);

        } else {
            $('.qz_text_input').addClass('needsAction');
            setTimeout(function () {
                $('.qz_text_input').removeClass('needsAction');
            }, 500);
        }


    });

    $('.Quiz_header_back').click(function () {
        var current_index = parseFloat($('.Quiz_header_back').attr('data-current'));
        if (current_index > 1) {
            var next_index = current_index - 1;
            $('.Quiz_header_back').attr('data-current', next_index);
            $('.Quiz_question').hide();
            $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
            calculateTop();
        } else {

        }
    });


    $('.Science_cell_header__js').click(function () {
        $(this).toggleClass('active');
        $(this).find('.Offer_science_cell_text').slideToggle();
    });

    $('.Offer_faq_tab').click(function () {
        $(this).toggleClass('active');
        $(this).find('.Offer_faq_answer').slideToggle();
    });

    $('.Header_scroll_js').click(function () {
        var window_url = String(window.location);
        if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1) {

        }
        $('html, body').animate({
            scrollTop: $(".Offer__section__js").offset().top - 100
        }, 500);
    });

// 15minutes timer

    function shortTimer() {
        function timerCountDown() {
            var timeLeft = parseFloat($('.Offer_get_your_plan_timer_seconds').attr('data'));
            timeLeft--;
            $('.Offer_get_your_plan_timer_seconds').attr('data', timeLeft);
            var minutes = timeLeft / 60;
            minutes = Math.floor(minutes);
            var seconds = timeLeft - (minutes * 60);
            // console.log(minutes, seconds, 'timer');
            $('.Offer_get_your_plan_timer_minutes').text(minutes);
            $('.Offer_get_your_plan_timer_seconds').text(seconds);
        }

        setInterval(timerCountDown, 1000);

    }

    shortTimer();


// Random numbers generator 

    function getRandomArbitrary(min, max) {
        return Math.round(Math.random() * (max - min) + min);
    }

    var similar_result = getRandomArbitrary(75, 87);
    var statistic_data_1 = getRandomArbitrary(76, 86);
    var statistic_data_2 = getRandomArbitrary(65, 76);
    var statistic_data_3 = getRandomArbitrary(41, 58);
    var your_score = getRandomArbitrary(25, 34);

// $('.Offer_procrastination_similar_score').text(similar_result+'%');
    $('.summary_number_1__js').text(statistic_data_1 + '%');
    $('.summary_number_2__js').text(statistic_data_2 + '%');
    $('.summary_number_3__js').text(statistic_data_3 + '%');

});


function runEmailChecker() {

    // Calculating Percentage

    function Calculating() {
        var data = parseFloat($('.Quiz_calculating_percent__js').attr('data'));
        if (data < 100) {
            if (data < 20) {
                data++;
            }
            if (data >= 20 && data < 22) {
                data += 0.15;
            }
            if (data >= 22 && data < 29) {
                data += 1.3;
            }
            if (data >= 29 && data < 32) {
                data += 3;
            }
            if (data >= 32 && data < 45) {
                data += 4;
            }
            if (data >= 45 && data < 48) {
                data += 0.7;
            }
            if (data >= 48 && data < 57) {
                data += 1.4;
            }
            if (data >= 57 && data < 87) {
                data += 4;
            }
            if (data >= 87 && data < 93) {
                data += 2.3;
            }
            if (data >= 93 && data < 97) {
                data += 4;
            }
            if (data >= 97 && data < 100) {
                data += 0.4;
            }
            if (data >= 100) {
                var next_url = $('.Quiz_calculating_percent__js').attr('next_url');
                window.location.replace(next_url);
            }
        }
        data_rounded = Math.round(data);
        $('.Quiz_calculating_percent__js').attr('data', data);
        $('.Quiz_calculating_percent__js').text(data_rounded + '%');
    }

    function Start_calculating() {
        setInterval(Calculating, 100);
    }


    $('.Quiz_question').hide();
    $('.Quiz_loading_page').css('display', 'flex');
    $('.Quiz-header_progres_bar__inner').css('width', '100%');
    // $('.Quiz_header_question_info_js').text(only_questions+'/'+only_questions);
    $('.Quiz_header_back').css('opacity', '0');
    $('.Quiz_header_back').css('cursor', 'default');
    setTimeout(function () {
        $('.Quiz_question').hide();
    }, 100);
    Start_calculating();
}


// Middle calculation
function MiddleCalculating() {
    var data = parseFloat($('.Quiz_middle_loading__js').attr('data'));
    if (data < 100) {
        if (data < 20) {
            data++;
        }
        if (data >= 20 && data < 22) {
            data += 0.15;
        }
        if (data >= 22 && data < 29) {
            data += 1.3;
        }
        if (data >= 29 && data < 32) {
            data += 3;
        }
        if (data >= 32 && data < 45) {
            data += 4;
        }
        if (data >= 45 && data < 48) {
            data += 0.7;
        }
        if (data >= 48 && data < 57) {
            data += 0.4;
        }
        if (data >= 57 && data < 87) {
            data += 3;
        }
        if (data >= 87 && data < 93) {
            data += 2;
        }
        if (data >= 93 && data < 97) {
            data += 4;
        }
        if (data >= 97 && data < 100) {
            data += 0.4;
        }
        if (data >= 100) {
            //    Passing to the next part of Quiz
            var current_index = parseFloat($('.Quiz_middle_loading__js').attr('data-index'));
            var next_index = current_index + 1;
            var next_question_index = parseFloat($('.Quiz_question_' + current_index + '__js').attr('data-question-index'));
            console.log(current_index, next_index, next_question_index);
            // Indexing quiz questions
            var current_url = window.location.href;
            if (current_url.indexOf('#') != -1) {
                var next_url_index = next_index;
                var new_url = url_splitted[0] + '#' + next_url_index;
                // console.log(new_url);

            }
            // console.log(next_index);
            $('.Quiz_question').hide();
            $('.Quiz_question_' + next_index + '__js').css('display', 'flex');
            // Progress bar width selection
            var width;
            var question_length = parseFloat($('.Question_amount').val()) + 1;
            var only_questions = parseFloat($('.Question_amount').attr('data-questions_amount'));
            var multiplier = 100 / only_questions;
            // if (next_index < 6){
            //     width = (next_index+2) * multiplier;
            // }
            // else if (next_index >= 6 && next_index < 12){
            //     width = (next_index +1)* multiplier;
            // }
            // else{
            //     width = next_index *multiplier;
            //  }
            width = (next_index) * multiplier;
            // $('.Quiz-header_progres_bar__inner').css('width', width+'%');
            $('.Quiz_header_question_info_js').text(next_question_index + '/' + only_questions);
            $('.Quiz_header_back').css('opacity', '1');
            $('.Quiz_header_back').css('cursor', 'pointer');
            $('.Quiz_header_back').attr('data-current', next_index);
        }
    }
    data_rounded = Math.round(data);
    $('.Quiz_middle_loading__js').attr('data', data);
    $('.Quiz_middle_loading__js').text(data_rounded + '%');
}

function Start_middle_calculating() {
    setInterval(MiddleCalculating, 100);
}

// Buy products tracking with analytics

$(document).on('click', '.Offer_product_atc_button', function () {
    var currentTitle = $(this).attr('ga_data');
    console.log(currentTitle);

    var window_url = String(window.location);
    if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1) {
    }

});

$(document).on('click', '.Thrive_Cart_close_buton', function () {
    var window_url = String(window.location);
    if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1) {
    }
});


$('.Thrive_Cart_close_buton').click(function () {
    location.reload();
    // Enable redirect for exit intent
    var wait_url = $('.wait_page_url').attr('data');
    if (typeof wait_url === "undefined") {
        wait_url = '/pages/wait';
    }
    window.location = wait_url;
});

$(document).on('click', '.thrivecart-button', function () {
    $('.Thrive_Cart_close_buton').show();
});


$('.Offer_main_includes_form_button').click(function () {
    var window_url = String(window.location);
    if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1) {
    }
    $('html, body').animate({
        scrollTop: $(".Offer__section__js").offset().top - 50
    }, 500);
});

$('.Main_offer_buttons').click(function () {
    var window_url = String(window.location);
    if (window_url.indexOf('main-3') != -1 || window_url.indexOf('sale-offer') != -1) {
    }
    $('html, body').animate({
        scrollTop: $(".Offer__section__js").offset().top - 50
    }, 500);
});


$('.Offer_main_faq_cell').click(function () {
    if ($(this).hasClass('active')) {
        $(this).toggleClass('active');
        $(this).find('.Faq_thumb').slideToggle();
    } else {
        $(this).toggleClass('active');
        $('.Faq_thumb').slideUp();
        $(this).find('.Faq_thumb').slideToggle();
    }
    // $('.Faq_thumb').removeClass('loaded_active');
});


$('.qz_product_card_view').click(function () {
    var currentId = $(this).attr('data-id');

    $('.qz_product_popup_outer[data-id="' + currentId + '"]').css('display', 'flex');


    $('.pp_Media.media_outer_cont').removeClass('loading');
    $('.qz_product_popup_in').css('opacity', '1');
    $('.qz_product_popup_outer').css('animation', 'fadeIn 0.5s forwards');
});


$('.pp_variant_sel').click(function () {
    $(this).closest('.pp_variant_selection').find('.pp_variant_sel').removeClass('active');
    $(this).addClass('active');
    console.log('selecting variant');
    var currentId = $(this).attr('data-id');

    if ($(this).hasClass('qz_product')) {
        $(this).closest('.qz_product_cell_content').find('.pp_default_pricing').hide();
        $(this).closest('.qz_product_cell_content').find('.pp_default_pricing[data-id="' + currentId + '"]').css('display', 'flex');

        $(this).closest('.qz_product_cell_content').find('.qz_product_card_atc').attr('data-id', currentId);
    } else {
        $('.pp_default_pricing').hide();
        $('.pp_default_pricing[data-id="' + currentId + '"]').css('display', 'flex');

        $('.pp_form_prices__js').hide();
        $('.pp_form_prices__js[data-id="' + currentId + '"]').show();

        $('.ppPackPrice_cont').hide();
        $('.ppPackPrice_cont[data-id="' + currentId + '"]').show();

        $('.pp_sku__js').hide();
        $('.pp_sku__js[data-id="' + currentId + '"]').show();

        $('.pp_square_img__js').hide();
        $('.pp_square_img__js[data-id="' + currentId + '"]').show();

        checkPricing();

        $('.pp_atc_form__Var').attr('value', currentId);

        $('.ppUpdPrice__js').hide();
        $('.ppUpdPrice__js[data-id="' + currentId + '"]').show();


        //  Updated layout
        $('.pp_bundle_price_upd').hide();
        $('.pp_bundle_price_upd[data-id="' + currentId + '"]').show();

        var currentInv = $('.pp_variant_sel.active').attr('data-inv');
        if (currentInv == '0') {
            $('.ppAtcBtn').prop('disabled', true);
            $('.ppAtcBtn').find('.text').html('Sold out');
            $('#Globo-Back-In-Stock').show();
        } else {
            $('.ppAtcBtn').prop('disabled', false);
            $('.ppAtcBtn').find('.text').html('Add to cart');
            $('#Globo-Back-In-Stock').hide();
        }

        $('.ppMedia_Outer__variant').addClass('hidden');
        $('.ppMedia_Outer__variant[data-id="' + currentId + '"]').removeClass('hidden');

        $('.media_outer_cont').addClass('loading');

        setTimeout(function () {
            $('.media_outer_cont').removeClass('loading');
            $('.pp_carousel_main')[0].slick.goTo(0);
        }, 500);
        //
        // $('.pp_carousel_main')[0].slick.refresh();
        // $('.pp_carousel_thumb')[0].slick.refresh();
    }

    $(this).closest('.qz_product_cell').find('.qz_product_card_pricing_line').hide();
    $(this).closest('.qz_product_cell').find('.qz_product_card_pricing_line[data-id="' + currentId + '"]').show();

    $(this).closest('.qz_product_cell').find('.qz_product_card_atc').attr('data-id', currentId);

});

$('.qz_product_popup_close').click(function () {

    $('.qz_product_popup_outer').hide();
    $('.qz_product_popup_in').css('opacity', '0');
    $('.qz_product_popup_outer').css('animation', 'fadeOut 0.5s forwards');

});

if ($('.pp_carousel_main').length) {
    $('.pp_carousel_main').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.pp_carousel_thumb',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    dots: true
                }
            }
        ]
    });
}


if ($('.pp_carousel_thumb').length) {
    $('.pp_carousel_thumb').slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        asNavFor: '.pp_carousel_main',
        focusOnSelect: true
    });
}

$('.ppAccordionCell').click(function () {
    $(this).toggleClass('active');
    $(this).find('.ppAccordionContent').slideToggle();
});

function convertToQuestionAnswerObject(dataString) {
    var questionAnswerObject = {};
    var pairs = dataString.split('/');

    pairs.forEach(function (pair) {
        var parts = pair.split('==');
        if (parts.length === 2) {
            var question = parts[0].trim();
            var answer = parts[1].trim();
            questionAnswerObject[question] = answer;
        }
    });

    return questionAnswerObject;
}

function saveToLocalStorage() {
    var dataString = $('.Question_amount').attr('data-quiz-data');

    var questionAnswers = convertToQuestionAnswerObject(dataString);

    var orderedKeys = Object.keys(questionAnswers);

    var name = questionAnswers[orderedKeys[0]];
    var catdog = questionAnswers[orderedKeys[1]];
    var sex = questionAnswers[orderedKeys[2]];
    var old = questionAnswers[orderedKeys[3]];
    var color = questionAnswers[orderedKeys[4]];
    var type = questionAnswers[orderedKeys[5]];
    var weight = questionAnswers[orderedKeys[6]];
    var currentFood = questionAnswers[orderedKeys[7]];
    var fussyEater = questionAnswers[orderedKeys[8]];
    var DigestiveIssues = questionAnswers[orderedKeys[9]];
    var Problems = questionAnswers[orderedKeys[10]];
    var Activity = questionAnswers[orderedKeys[11]];
    var Body = questionAnswers[orderedKeys[12]];
    var Allergies = questionAnswers[orderedKeys[13]];

    var quizData = {
        Name: name,
        CatDog: catdog,
        Sex: sex,
        Old: old,
        Color: color,
        Type: type,
        Weight: weight,
        CurrentFood: currentFood,
        FussyEater: fussyEater,
        DigestiveIssues: DigestiveIssues,
        Problems: Problems,
        Activity: Activity,
        Body: Body,
        Allergies: Allergies,
        petBreed: window.localStorage.getItem('breed') || 'Not Sure',
    };
    if (window.localStorage.getItem('quiz-data')) {
        var oldData = JSON.parse(window.localStorage.getItem('quiz-data'));
        // Ensure oldData is an array
        if (!Array.isArray(oldData)) {
            oldData = [oldData];
        }
        // Add new data to the array
        oldData.push(quizData);
        window.localStorage.setItem('quiz-data', JSON.stringify(oldData));
    } else {
        // Initialize with an array containing the new data
        window.localStorage.setItem('quiz-data', JSON.stringify([quizData]));
    }
}

function sendDataToSheet() {

    var dataString = $('.Question_amount').attr('data-quiz-data');

    var questionAnswers = convertToQuestionAnswerObject(dataString);

    var orderedKeys = Object.keys(questionAnswers);

    var name = questionAnswers[orderedKeys[0]];
    var catdog = questionAnswers[orderedKeys[1]];
    var sex = questionAnswers[orderedKeys[2]];
    var old = questionAnswers[orderedKeys[3]];
    var color = questionAnswers[orderedKeys[4]];
    var type = questionAnswers[orderedKeys[5]];
    var weight = questionAnswers[orderedKeys[6]];
    var currentFood = questionAnswers[orderedKeys[7]];
    var fussyEater = questionAnswers[orderedKeys[8]];
    var DigestiveIssues = questionAnswers[orderedKeys[9]];
    var Problems = questionAnswers[orderedKeys[10]];
    var Activity = questionAnswers[orderedKeys[11]];
    var Body = questionAnswers[orderedKeys[12]];
    var Allergies = questionAnswers[orderedKeys[13]];

    var data = {
        Name: name,
        CatDog: catdog,
        Sex: sex,
        Old: old,
        Color: color,
        Type: type,
        Weight: weight,
        CurrentFood: currentFood,
        FussyEater: fussyEater,
        DigestiveIssues: DigestiveIssues,
        Problems: Problems,
        Activity: Activity,
        Body: Body,
        Allergies: Allergies
    };


    // console.log(data, 'DATA');

    var googleScriptURL = "https://script.google.com/macros/s/AKfycbxuXiDL1gFWCoA4P0MpwDUTWiyIRqRkghHNk2_GhwSK_DjNEXQYsKj3q2kpAhPd9RQQhw/exec";

    // Convert data to query parameters
    var urlParams = new URLSearchParams(data).toString();


    fetch(googleScriptURL + "?" + urlParams)
        .then(response => response.text())
        .then(data => console.log("Success:", data))
        .catch(error => console.error("Error:", error));
}

$(document).on('click', '.qz_product_card_atc', function (evt) {
    evt.preventDefault();
    var currentId = $(this).attr('data-id');
    var currentQty = $(this).closest('.qz_product_cell').attr('data-qty');
    var mode = $('.qz_btn_mode.active').attr('data');
    var sellingId = $(this).closest('.qz_product_cell').find('.qz_product_quantity__select[data-id="' + currentId + '"]').val();

    var data;

    if (mode == 'subscribe') {
        data = {
            id: currentId,
            quantity: currentQty,
            selling_plan: sellingId,
            properties: {
                "Personalized": "Specific"
            }
        };
    } else {
        data = {
            id: currentId,
            quantity: currentQty,
            properties: {
                "Personalized": "Specific"
            }
        };
    }

    // console.log("Adding to cart:", data);

    // First, add the product to the cart
    let addedItemData = null;

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(Object.assign({}, data, {sections: 'cart-drawer,cart-icon-bubble'}))
    })
        .then(response => {
            if (!response.ok) return response.json().then(err => { throw new Error(err.description || 'Could not add to cart'); });
            return response.json();
        })
        .then(addedItem => {
            addedItemData = addedItem;

            // Now fetch current cart data
            return fetch('/cart.js')
                .then(response => response.json());
        })
        .then(cartData => {
            // Merge new attributes with existing ones
            let updatedAttributes = cartData.attributes || {};
            updatedAttributes["Personalized"] = "Specific";

            // Send updated attributes
            return fetch('/cart/update.js', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({attributes: updatedAttributes})
            });
        })
        .then(response => response.json())
        .then(() => {
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && addedItemData && addedItemData.sections) {
                cartDrawer.renderContents(addedItemData);
            } else if (cartDrawer) {
                cartDrawer.open();
            }
            // Stay on quiz page — no redirect
        })
        .catch(error => console.error('Error:', error));
});